module.exports = __webpack_public_path__ + "static/media/star.0d681810.svg";